import React, { memo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Badge, Box, ButtonBase, Tooltip, Typography } from '@mui/material';
import { OmegaIcon } from 'app/pages/loanApplication/tabs/aiChat/icons';

import { setIsPanelOpenAction } from 'store/aiChat/actions';
import { selectAiChatIsPanelOpen, selectAiChatUnreadCount } from 'store/aiChat/selectors';

import {
  AI_ASSISTANT_LAUNCHER_LABEL,
  AI_ASSISTANT_LAUNCHER_TOOLTIP,
  AiAssistantTestId,
} from '../../AiAssistant.constants';

import { LAUNCHER_ICON_SIZE } from './AiAssistantLauncher.constants';
import {
  launcherBadgeStyles,
  launcherButtonStyles,
  launcherContainerStyles,
  launcherIconWrapperStyles,
  launcherLabelWrapperStyles,
  launcherPrimaryLabelStyles,
  launcherSecondaryLabelStyles,
} from './AiAssistantLauncher.styles';
import { getBadgeContent, getSublabel } from './AiAssistantLauncher.utils';

const AiAssistantLauncher = () => {
  const dispatch = useDispatch();

  const isPanelOpen = useSelector(selectAiChatIsPanelOpen);
  const unreadCount = useSelector(selectAiChatUnreadCount);

  const [isHovered, setIsHovered] = useState(false);

  const onMouseEnter = useCallback(() => setIsHovered(true), []);
  const onMouseLeave = useCallback(() => setIsHovered(false), []);

  const onOpen = useCallback(() => {
    dispatch(setIsPanelOpenAction(true));
  }, [dispatch]);

  if (isPanelOpen) {
    return null;
  }

  const badgeContent = getBadgeContent(unreadCount);
  const sublabel = getSublabel(unreadCount);

  return (
    <Box sx={launcherContainerStyles}>
      <Tooltip placement="left" title={isHovered ? '' : AI_ASSISTANT_LAUNCHER_TOOLTIP}>
        <Badge
          badgeContent={badgeContent}
          data-testid={AiAssistantTestId.LAUNCHER_BADGE}
          invisible={unreadCount <= 0}
          overlap="circular"
          sx={launcherBadgeStyles}
        >
          <ButtonBase
            aria-label={AI_ASSISTANT_LAUNCHER_TOOLTIP}
            data-testid={AiAssistantTestId.LAUNCHER}
            sx={launcherButtonStyles(isHovered)}
            onBlur={onMouseLeave}
            onClick={onOpen}
            onFocus={onMouseEnter}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            <Box sx={launcherIconWrapperStyles}>
              <OmegaIcon size={LAUNCHER_ICON_SIZE} />
            </Box>
            <Box sx={launcherLabelWrapperStyles(isHovered)}>
              <Typography sx={launcherPrimaryLabelStyles} variant="medium14">
                {AI_ASSISTANT_LAUNCHER_LABEL}
              </Typography>
              <Typography sx={launcherSecondaryLabelStyles} variant="regular12">
                {sublabel}
              </Typography>
            </Box>
          </ButtonBase>
        </Badge>
      </Tooltip>
    </Box>
  );
};

export default memo(AiAssistantLauncher);
